// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.analytic_category_enum */
var AnalyticCategoryEnum;
(function (AnalyticCategoryEnum) {
    AnalyticCategoryEnum["analysis"] = "analysis";
    AnalyticCategoryEnum["report"] = "report";
    AnalyticCategoryEnum["utility"] = "utility";
})(AnalyticCategoryEnum || (AnalyticCategoryEnum = {}));
;
export default AnalyticCategoryEnum;
/** Zod schema for analytic_category_enum */
export const analyticCategoryEnum = z.nativeEnum(AnalyticCategoryEnum);
//# sourceMappingURL=AnalyticCategoryEnum.js.map